import queryString from "querystring";
import { LANGUAGES_CODE } from "./constants";

export const convertLanguageCulture = languageCulture => {
  if (!languageCulture || languageCulture.length < 2) {
    return LANGUAGES_CODE.EN;
  }

  if (languageCulture.toLowerCase().startsWith(LANGUAGES_CODE.FI)) {
    return LANGUAGES_CODE.FI;
  }

  if (languageCulture.toLowerCase().startsWith(LANGUAGES_CODE.SV)) {
    return LANGUAGES_CODE.SV;
  }

  return LANGUAGES_CODE.EN;
};

export const getQueryStringValues = function() {
  let href = window.location.href;
  let qs = href.split("?");
  if (qs[1]) {
    return queryString.parse(qs[1]);
  }
  return null;
};



// WEBPACK FOOTER //
// ./src/utils/helpers.js